import { render, staticRenderFns } from "./MenusSave.vue?vue&type=template&id=085831cc&scoped=true"
import script from "./MenusSave.vue?vue&type=script&lang=js"
export * from "./MenusSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085831cc",
  null
  
)

export default component.exports